import { groupBy, keys, map } from 'lodash/fp';

import {
  GET_BEST_SELLERS_QUERY,
  GET_PRODUCT_TYPES_BY_INSURANCE_TYPE_QUERY,
  GET_PRODUCTS_BY_TYPE_QUERY,
} from '../../../src/client/pages/insurance/queries';
import type { ProductsByType } from '../../../src/client/pages/insurance/types';
import type { ProductType, ProductTypeType } from '../../../src/client/types/sanity';

export type ProductWithAllProduct = { allProduct: ProductType[] };
export type ProductTypeWithAllProductType = { allProductType: ProductTypeType[] };
/*
  We retrieve products from sanity by getting the product types for an insurance type first. Then we get the products for each of the types.
*/
// @ts-expect-error - Automatic, Please fix when editing this file
const getProductsByType = async ({ client, type }): Promise<ProductsByType[]> => {
  const productTypeData: ProductTypeWithAllProductType = await client(GET_PRODUCT_TYPES_BY_INSURANCE_TYPE_QUERY, {
    variables: { type },
  });
  const productTypes: string[] = map('identifier.current', productTypeData.allProductType);

  const [products, bestSellers] = await Promise.all([
    client(GET_PRODUCTS_BY_TYPE_QUERY, { variables: { productTypes } }),
    client(GET_BEST_SELLERS_QUERY, { variables: { productTypes } }),
  ]);

  const groupedByProductType = groupBy('productType.identifier.current', products?.allProduct);
  const bestSellerIds = new Set(map('product.identifier.current', bestSellers?.allBestSeller));

  const sortedProductsArray = map(
    (productType) => ({
      productType,
      products: map(
        (product) => ({
          ...product,
          isBestSeller: bestSellerIds.has(product.identifier.current),
        }),
        groupedByProductType[productType],
      ),
    }),
    keys(groupedByProductType),
  );
  return sortedProductsArray;
};

export default getProductsByType;
